import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import CPTCodeSelectW from "../CPTCodeSelectW";
import DiagCodeSelectW from "../DiagCodeSelectW";
import LabRequest from "../ehr/LabRequest";
import HTMLEditor from "../HTMLEditor";
import Icon from "../Icon";
import ImageGallery from "../ImageGallery";
import ProductSelectW from "../ProductSelectW";
import Switch from "../Switch";
import Meds from "../visit/Meds";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './Workflow.css';

class Workflow extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            info: {},
            iters: {}
        };
    }

    async componentDidMount() {
        await this.fillListAsync('/api/workflow/fieldtype/list', 'fieldTypes');
        await this.fillItemAsync('/api/workflow/get/' + this.props.struct.id, 'struct');
        await this.load();
    }


    load = async () => {
        try {
            let j = await qreq.getAsync('/api/workflow/data/' + this.props.struct.id + '/visit/' + this.props.visit.id);
            if (j.errorCode === 0) {
                this.sanitizeData(j.item.data);
                this.processData(j.item.data);
                this.setState({ info: j.item.data });
            }
            else if(j.errorCode === 7)
                this.loadHistory();
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadHistory = async () => {
        try {
            let j = await qreq.getAsync('/api/workflow/data/' + this.props.struct.id + '/visit/' + this.props.visit.id + '/history');
            if (j.errorCode === 0) {
                this.processData(j.item.data);
                this.setState({ info: j.item.data });
            }
            else if (j.errorCode !== 7)
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    export = () => {
        // todo: rename report
        window.open(Globals.serverUrl + `/api/workflow/report/pdf/${this.props.struct.id}/${this.props.visit.id}/report-${this.props.struct.id}-${this.props.visit.id}.pdf` + (this.props.ammend ? '?ammend=true' : ''));
    }

    processField = (data, field) => {
        var tp = this.getFieldType(field.fieldTypeID);

        // For Multi-Checkbox
        if (tp.htmlElementType === 'checkbox' && tp.isSelector && field.options) {
            try {
                if (data[field.ident]) {
                    let j = JSON.parse(data[field.ident]);
                    if (j) {
                        j.forEach(i => {
                            if (i.selected) {
                                let opt = field.options.find(x => x.value === i.value);
                                if (opt)
                                    opt.selected = true;
                            }
                        });
                    }
                }
            }
            catch (e) {
                console.error('Error', 'processData', e);
            }
        }
        else if (tp.htmlElementType === 'radio') {
            let val = data[field.ident];
            if (val) {
                // HINT: maybe there is a better way of doing this
                if(val[0] === '[') {
                    try {
                        let j = JSON.parse(val);
                        if(j && j.length) {
                            let z = j.find(x => x.selected);
                            if(z) {
                                let opt = field.options.find(m => m.value === z.value);
                                if(opt)
                                    opt.selected = true;
                            }
                        }
                    }
                    catch(e) {
                        console.error('radio error', e);
                    }
                }
                let opt = field.options.find(x => x.value === val);
                if (opt)
                    opt.selected = true;
            }
        }
    }

    processData = (data) => {
        let struct = { ...this.state.struct };
        let iters = {};
        struct.sections.forEach(section => {
            if (section.isIteration) {
                let sub = JSON.parse(data[section.ident]);
                if (!sub) return;
                let iidx = 0;
                sub.forEach(j => {
                    if (!iters[section.ident])
                        iters[section.ident] = [];
                    iters[section.ident].push(j);
                    this.generateSummary(section, iters[section.ident], iidx);
                    iidx++;
                });
            }
            else {
                section.fields.forEach(field => this.processField(data, field));
                this.generateSummary(section);
            }
        });
        this.setState({ struct, iters });
    }

    getFieldType = (id) => {
        return this.state.fieldTypes?.find(i => i.id === parseInt(id));
    }

    setValue = (field, e, iter, iterIdx, section) => {
        let info = { ...this.state.info };
        if (iter)
            iter[field.ident] = e.target.value;
        else
            info[field.ident] = e.target.value;
        this.setState({ info: info });
        this.generateSummary(section, iter, iterIdx);
    }

    setValueRaw = (field, raw, iter, iterIdx, section) => {
        let info = { ...this.state.info };
        if (iter)
            iter[field.ident] = raw;
        else
            info[field.ident] = raw;
        this.setState({ info: info });
        this.generateSummary(section, iter, iterIdx);
    }

    setValueImage = (field, raw, iter, iterIdx, section) => {
        let info = { ...this.state.info };


        raw.forEach(i => {
            if (i.base64Content)
                delete i.base64Content;
            i.images?.forEach(j => {
                if (j.base64Content)
                    delete j.base64Content;
            });
        });

        if (iter)
            iter[field.ident] = JSON.stringify(raw);
        else
            info[field.ident] = JSON.stringify(raw);
        this.setState({ info: info });
        this.generateSummary(section, iter, iterIdx);
    }

    getValue = (field, iter, iterIdx) => {
        if (iter)
            return iter[field.ident] || '';
        else
            return this.state.info[field.ident] || '';
    }

    toggleCheckbox = (field, e, on, iter, iterIdx, section) => {
        let info = { ...this.state.info };
        if (iter)
            iter[field.ident] = on;
        else
            info[field.ident] = on;
        this.setState({ info: info });
        this.generateSummary(section, iter, iterIdx);
    }

    // TODO: ~~~ something happens when you toggle another multi-checkbox that for some reason hides the extrassssss
    toggleOptionCheckbox = (field, opt, e, on, iter, iterIdx, section) => {
        let info = { ...this.state.info };
        opt.selected = on;
        if (iter) {
            if(!iter[field.ident]) iter[field.ident] = '[]';
            let j = JSON.parse(iter[field.ident]);

            field.options.forEach(i => {
                let find = j.find(x => x.value === i.value);
                if (find) {
                    i.extra = find.extra;
                    i.isExtra = find.isExtra;
                }
            });

            iter[field.ident] = JSON.stringify(field.options); //original
        }
        else
            info[field.ident] = JSON.stringify(field.options);
        this.setState({ info: info });
        this.generateSummary(section, iter, iterIdx);
    }

    setOptionExtra = (field, opt, e, extra, iter, iterIdx, section) => {
        let info = { ...this.state.info };

        opt.extra = extra;
        if (extra) opt.selected = true;

        if (iter) {
            iter[field.ident] = JSON.stringify(field.options);
        }
        else
            info[field.ident] = JSON.stringify(field.options);
        this.setState({ info: info });
        this.generateSummary(section, iter, iterIdx);
    }

    getOptValue = (field, opt, iter, iterIdx, section) => {
        if (iter) {
            if (!iter[field.ident])
                return false;
            try {
                let j = JSON.parse(iter[field.ident]);
                let find = j.find(x => x.value === opt.value);
                if (find) {
                    return find.selected;
                }
            }
            catch (e) {
                return opt.value === iter[field.ident];
            }
        }
        return opt.selected;
    }

    // TODO: revise whyyy JSON.parse consumes a nulllll
    getOptionExtra = (field, opt, iter, iterIdx) => {

        try {
            let j = JSON.parse(iter ? iter[field.ident] : this.state.info[field.ident]);
            let find = j.find(x => x.value === opt.value);
            if (find)
                return find.extra;
        }
        catch {
        }
        return '';
    }

    toggleValue = (field, e, opt, iter, iterIdx, section) => {
        let info = { ...this.state.info };
        field.options.forEach(i => {
            i.selected = false;
        });
        opt.selected = true;
        if (iter)
            iter[field.ident] = opt.value;
        else
            info[field.ident] = opt.value;

        this.setState({ info: info });
        this.generateSummary(section, iter, iterIdx);
    }

    placeholder = (s) => {
        return s?.replace(/#/g, '_');
    }

    // TODO: pass the info for the state, remove the timeout ~~~~~
    generateSummary = (section, iter, iterIdx) => {

        if (!section.isSummaryEdit) return;


        setTimeout(() => {

            let summary = [];
            section.fields.forEach(f => {

                var tp = this.getFieldType(f.fieldTypeID);
                if (!tp) return null;

                let toPush = [];
                

                if (tp.htmlElementType === 'radio') {
                    let find = f.options.find(x => x.selected);
                    if (find) {
                        toPush.push(find.value);
                        if(find.extra)
                            toPush.push(find.extra); 
                    }
                }
                else if (tp.htmlElement === 'input') {
                    if (tp.htmlElementType === 'checkbox') {
                        if (tp.isSelector) {
                            f.options.forEach(opt => {
                                let val = this.getOptValue(f, opt, iter, iterIdx, section);
                                if (val) {
                                    toPush.push(opt.value);
                                    if(opt.extra)
                                        toPush.push(opt.extra);
                                }
                            });
                        }
                        else {
                            let val = this.getValue(f, iter, iterIdx);
                            if (val)
                                toPush.push(f.name);
                        }
                    }
                    else {
                        let val = this.getValue(f, iter, iterIdx);
                        if (val)
                            toPush.push(val);
                    }
                }
                else {
                    // exclude components
                    if(tp.htmlElement !== 'Medications'
                        && tp.htmlElement !== 'CPTCodes'
                        && tp.htmlElement !== 'DiagCodes'
                        && tp.htmlElement !== 'ImageGallery')
                    {
                        let val = this.getValue(f, iter, iterIdx);
                        if (val)
                            toPush.push(val)
                    }
                }
                
                // push if value
                if(toPush.length > 0)
                {
                    if(tp.htmlElementType !== 'checkbox')
                        summary.push(f.name);
                    summary.push(...toPush);
                }

            });
            let info = {...this.state.info};
            if(iter)
                iter['___summary___'] = summary.join(' ');
            else
                info[section.ident + '_summary'] = summary.join(' ');
            this.setState({ info: info });
        }, 100);
    }
    
    changeSummary = (section, e, iter) => {
        if(iter) {
            iter['___summary___'] = e;
            this.setState({ info: {...this.state.info }});
        }
        else {
            let info = {...this.state.info};
            info[section.ident + '_summary'] = e;
            this.setState({ info });
        }
    }

    getSummary = (section, iter) => {
        if(iter)
            return iter['___summary___'] || '';
        else
            return this.state.info[section.ident + '_summary'] || '';
    }

    field = (f, iter, iterIdx, section, sectionIdx) => {
        var tp = this.getFieldType(f.fieldTypeID);
        if (!tp) return null;

        // Radio
        if (tp.htmlElementType === 'radio') {
            
            return <div>
                {f.options?.map((opt, kdx) => <div key={sectionIdx + '-' + iterIdx + '-' + kdx}>
                    <input
                        type="radio"
                        onChange={(e) => this.toggleValue(f, e, opt, iter, iterIdx, section)}
                        checked={this.getOptValue(f, opt, iter, iterIdx, section)}
                        disabled={this.props.locked}
                    /> {opt.value}
                    
                    {this.getOptValue(f, opt, iter, iterIdx, section)
                        && opt.isExtra
                        && <input type="text" className="form-control"
                            onChange={(e) => this.setOptionExtra(f, opt, e, e.target.value, iter, iterIdx, section)}
                            value={this.getOptionExtra(f, opt, iter, iterIdx)}
                            disabled={this.props.locked}
                        /> /* EXTRA */}
                </div>)}
            </div>;
        }
        // Input
        else if (tp.htmlElement === 'input') {
            if (tp.htmlElementType === 'checkbox') {
                if (tp.isSelector) { // multi-checkbox, radio
                    return <div>
                        {f.options?.map((opt, kdx) => <div key={sectionIdx + '-' + iterIdx + '-' + kdx}>
                            <Switch
                                checked={this.getOptValue(f, opt, iter, iterIdx, section)}
                                onChange={(e) => this.toggleOptionCheckbox(f, opt, e, e.target.checked, iter, iterIdx, section)}
                                label={opt.value}
                                disabled={this.props.locked}
                            />
                            {this.getOptValue(f, opt, iter, iterIdx, section)
                                && opt.isExtra
                                && <input type="text" className="form-control"
                                    onChange={(e) => this.setOptionExtra(f, opt, e, e.target.value, iter, iterIdx, section)}
                                    value={this.getOptionExtra(f, opt, iter, iterIdx)}
                                    disabled={this.props.locked}
                                /> /* EXTRA */}
                        </div>)}
                    </div>;
                }
                else {
                    return <Switch
                        checked={this.getValue(f, iter, iterIdx)}
                        onChange={(e) => this.toggleCheckbox(f, e, e.target.checked, iter, iterIdx, section)}
                        label={f.name}
                        disabled={this.props.locked}
                    />;
                }
            }
            else {
                return <input
                    type={tp.htmlElementType}
                    className="form-control"
                    onChange={(e) => this.setValue(f, e, iter, iterIdx, section)}
                    value={this.getValue(f, iter, iterIdx)}
                    placeholder={this.placeholder(f.fieldFormat)}
                    disabled={this.props.locked}
                />;
            }
        }
        // Textarea
        else if (tp.htmlElement === 'textarea')
            return <textarea
                className="form-control"
                onChange={(e) => this.setValue(f, e, iter, iterIdx, section)}
                value={this.getValue(f, iter, iterIdx)}
                disabled={this.props.locked}></textarea>;
        // Select
        else if (tp.htmlElement === 'select') {
            return <select className="form-control" onChange={(e) => this.setValue(f, e, iter, iterIdx, section)} defaultValue={this.getValue(f, iter, iterIdx)} disabled={this.props.locked}>
                <option>Select</option>
                {f.options?.map((opt, k) => <option key={k} value={opt.value} selected={this.getValue(f, iter, iterIdx) === opt.value}>{opt.value}</option>)}
            </select>;
        }
        // CPT Codes
        else if (tp.htmlElement === 'CPTCodes') {
            return <CPTCodeSelectW
                currentValues={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                onChange={(v) => this.setValueRaw(f, JSON.stringify(v), iter, iterIdx, section)}
                disabled={this.props.locked}
            />
        }
        // Products
        else if (tp.htmlElement === 'Products') {
            return <ProductSelectW
                currentValues={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                onChange={(v) => this.setValueRaw(f, JSON.stringify(v), iter, iterIdx, section)}
                disabled={this.props.locked}
            />
        }
        // Diag Codes
        else if (tp.htmlElement === 'DiagCodes') {
            return <DiagCodeSelectW
                noLabel
                currentValues={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                onChange={(v) => this.setValueRaw(f, JSON.stringify(v), iter, iterIdx, section)}
                disabled={this.props.locked}
            />;
        }
        // Meds
        else if (tp.htmlElement === 'Medications') {
            return <Meds
                noLabel
                list={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                onChange={(v) => this.setValueRaw(f, JSON.stringify(v), iter, iterIdx, section)}
                disabled={this.props.locked}
            />;
        }
        // Image Gallery
        else if (tp.htmlElement === 'ImageGallery') {
            return <div className="row">
                <div className="col-lg-3 col-md-6">
                    <ImageGallery
                        list={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                        onChange={(v) => this.setValueImage(f, v, iter, iterIdx, section)}
                        disabled={this.props.locked}
                    />
                </div>
            </div>;
        }
        else if (tp.htmlElement === 'LabRequest') {
            return <LabRequest
                list={JSON.parse(this.getValue(f, iter, iterIdx) || '[]')}
                onChange={(v) => this.setValueRaw(f, JSON.stringify(v), iter, iterIdx, section)}
                disabled={this.props.locked}
            />
        }
        return null;
    }

    sanitizeData = (data) => {
        for(let k in data) {
            if(data[k] && data[k].toLowerCase) {
                if(data[k].toLowerCase() === 'true')
                    data[k] = true;
                else if(data[k].toLowerCase() === 'false')
                    data[k] = false;
            }
        }
    }

    submit = async (e) => {
        e?.preventDefault();
        try {
            let iters = this.state.iters;
            let item = { ...this.state.struct, data: { ...this.state.info, visitid: this.props.visit.id } };
            for (var k in iters) {
                item.data[k] = iters[k];
            }
            this.sanitizeData(item.data);
            let j = await qreq.postAsync('/api/workflow/submit' + (this.props.ammend ? '?ammend=true' : ''), item);
            if (j.errorCode === 0) {
                this.success('Saved!');
                this.props?.onSave();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    addIteration = (section, data) => {
        if (!data) data = {};
        let iters = { ...this.state.iters };
        if (!iters[section.ident])
            iters[section.ident] = [];
        iters[section.ident].push(data);
        this.setState({ iters });
    }

    removeIteration = (section, iter) => {
        let iters = { ...this.state.iters };
        let idx = iters[section.ident].indexOf(iter);
        iters[section.ident].splice(idx, 1);
        this.setState({ iters });
    }

    mapIteration = (section) => {
        return this.state.iters[section.ident];
    }

    render() {
        return (
            <form onSubmit={this.submit}>
                <AppActions>
                    <button type="button" className="btn btn-lg btn-primary" onClick={this.export}>
                        <Icon icon="faFilePdf" /> <span className="d-none d-md-inline">Report</span>
                    </button>
                    {!this.props.locked && <button type="submit" className="btn btn-lg btn-success">
                        <Icon icon="faSave" /> <span className="d-none d-md-inline">Save</span>
                    </button>}
                </AppActions>
                {this.state.struct?.sections?.map((i, idx) => (
                    i.isIteration ? <>
                        <div key={idx}>
                            {this.mapIteration(i)?.map((j, jdx) => (
                                <div key={idx + '-' + jdx}>
                                    <Card
                                        title={i.name}
                                        headerButtons={!this.props.locked && <button type="button" className="btn btn-danger" onClick={() => this.removeIteration(i, j)}><Icon icon="faTrash" /></button>}
                                        isCollapse collapse>
                                        {i.fields.map((f, fdx) => (
                                            <div key={idx + '-' + jdx + '-' + fdx} className="form-group mb-3">
                                                {(this.getFieldType(f.fieldTypeID)?.htmlElementType !== 'checkbox' || this.getFieldType(f.fieldTypeID)?.isSelector) && <label className="form-label">{f.name}</label>}
                                                {this.field(f, j, jdx, i, idx)}
                                            </div>
                                        ))}
                                        {i.isSummaryEdit && <HTMLEditor linkValue value={this.getSummary(i, j)} className="form-control workflow-summary" onChange={(e) => this.changeSummary(i, e, j)} disabled={this.props.locked} />}
                                    </Card>
                                </div>
                            ))}
                            {!this.props.locked && <div className="mb-3">
                                <button type="button" className="btn btn-primary" onClick={() => this.addIteration(i)}><Icon icon="faPlus" /> Add {i.name}</button>
                            </div>}
                        </div>
                    </> : <Card key={idx} title={i.name} isCollapse collapse>
                        {i.fields.map((f, fdx) => (
                            <div key={idx + '-' + fdx} className="form-group mb-3">
                                {(this.getFieldType(f.fieldTypeID)?.htmlElementType !== 'checkbox' || this.getFieldType(f.fieldTypeID)?.isSelector) && <label className="form-label">{f.name}</label>}
                                {this.field(f, null, null, i, idx)}
                            </div>
                        ))}
                        {i.isSummaryEdit && <HTMLEditor linkValue value={this.getSummary(i)} className="form-control workflow-summary" onChange={(e) => this.changeSummary(i, e)} disabled={this.props.locked} />}
                    </Card>
                ))}
            </form>
        );
    }
}

export default withParamsAndNavigate(Workflow);